import { type TabsListVariant } from '~/components/component-library/Tabs/types'

export const TABS_LIST_CLASSNAME: Record<TabsListVariant, string> = {
  default: 'flex items-center space-x-6 border-b border-default',
  table: 'sticky left-0 flex w-fit items-center space-x-6 pl-4 md:pl-6 lg:pl-8',
  dense: 'flex items-center gap-1 px-1',
}

// Full-width border the w-fit list can't draw itself
export const TABS_LIST_TABLE_FRAME_CLASSNAME = 'border-b border-muted pt-4'

// Drawn as a sibling so an overflow-hidden trigger row can't clip it
export const TABS_LIST_DENSE_RULE_CLASSNAME = '-mt-px border-b border-default'

export const TABS_TRIGGER_BASE_CLASSNAME =
  'border-b-2 outline-none data-[state=active]:border-black data-[state=inactive]:border-transparent data-[state=inactive]:text-secondary data-[state=active]:dark:border-white'

const TABS_TRIGGER_STANDARD_CLASSNAME = '-mb-px px-1 pb-2 text-base font-medium'

export const TABS_TRIGGER_CLASSNAME: Record<TabsListVariant, string> = {
  default: TABS_TRIGGER_STANDARD_CLASSNAME,
  table: TABS_TRIGGER_STANDARD_CLASSNAME,
  dense: 'flex-shrink-0 px-2 py-1.5 text-sm font-normal',
}
